import {
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  Select,
  TextInput,
  Title,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState, useDisclosure, useHotkeys } from "@mantine/hooks";
import {
  IconBuildingSkyscraper,
  IconCalendar,
  IconSearch,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { changeSearchValue } from "../../../_base/helper/FunctionHelper";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import { getMasterOrgSelect } from "../../../service/getSelectApi";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const CompareDefectivePOSAndAsia = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [isCallFirst, setIsCallFirst] = useState<boolean>(false);
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [search, setSearch] = useState<any>({
    FromDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.FromDate
        : new Date(
            new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
              7 * 60 * 60 * 1000
          )?.toISOString(),
    ToDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.ToDate
        : new Date(new Date().getTime() + 7 * 3600 * 1000).toISOString(),
    MaCty: _searchJson && checkedPinSearch ? _searchJson?.MaCty : "",
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300
  );

  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(() => [], []);

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/CompareAsiaPos/doi-chieu-bang-ke?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryMdm.post<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        })
      );
    }
  };

  // const exportDataExcel = async () => {
  //   open();
  //   try {
  //     let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

  //     const params = new URLSearchParams();
  //     Object.entries(search).forEach(([key, value]) => {
  //       if (Array.isArray(value) && value.length > 0) {
  //         value.forEach((item) => params.append(key, String(item)));
  //       } else if (typeof value === "string" && value.length > 0) {
  //         params.append(key, value);
  //       }
  //     });

  //     if (keySearch.length > 0) {
  //       url += `&KeySearch=${keySearch?.trim()}`;
  //     }

  //     url += `&${params.toString()}`;

  //     const baseUrl = `/api/v1/ItemComparison/export-excel${url}`;

  //     const _url = BASE_API_MDM + baseUrl;
  //     const token = localStorage.getItem("token");

  //     const response = await fetch(_url, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/vnd.ms-excel",
  //         Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
  //       },
  //     });

  //     if (!response.ok) {
  //       NotificationExtension.Fails("Export Excel thất bại !");
  //     } else {
  //       const blob = await response.blob();
  //       const urlss = window.URL.createObjectURL(blob);
  //       const _name = new Date().toISOString().slice(0, 10);
  //       let filename = "danh_sach_voucher.xlsx";
  //       const link = document.createElement("a");
  //       link.href = urlss;
  //       link.download = filename;
  //       document.body.appendChild(link);
  //       link.click();
  //       link.remove();
  //       window.URL.revokeObjectURL(url);
  //       NotificationExtension.Success("Export Excel thành công !");
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     close();
  //   }
  // };

  const getDataBranchSelect = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const storedHeader = localStorage.getItem("userLoginHeader");

      const branchIdUser = storedHeader
        ? JSON.parse(storedHeader)?.branchId
        : null;

      const data = res
        .filter((i) => i.att1 && i.text)
        .map((i) => ({
          label: `${i.att1} - ${i.text}`,
          value: String(i.att1),
        }));

      if (!checkedPinSearch && branchIdUser) {
        setSearch((prev: any) => ({
          ...prev,
          MaCty: res.find((i) => String(i.value) === String(branchIdUser))
            ?.att1,
        }));
      }

      setDataBranchSelect(data);
      setIsCallFirst(true);
    }
  };

  useEffect(() => {
    if (isCallFirst) {
      fetchData();
    }
  }, [pagination?.pageIndex, pagination?.pageSize, isCallFirst]);

  useEffect(() => {
    getDataBranchSelect();
  }, []);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningCompareDefectivePOSAndAsia"
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["mrt-row-select", "mrt-row-numbers"],
          right: ["action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage()
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningCompareDefectivePOSAndAsia",
      JSON.stringify(columnPinning)
    );
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-numbers", "maVt"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Flex gap={"md"}>
            {/* <Button
                leftSection={<IconFileTypeCsv size={16} />}
                onClick={() => exportDataExcel()}
              >
                Export Excel
              </Button> */}
          </Flex>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa tìm kiếm"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.FromDate && search.FromDate?.length > 0
                  ? new Date(search.FromDate ?? "")
                  : null
              }
              maxDate={
                search.ToDate && search.ToDate?.length > 0
                  ? new Date(search.ToDate)
                  : new Date()
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000
                      )?.toISOString()
                    : "",
                  "FromDate",
                  setSearch
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.ToDate && search.ToDate?.length > 0
                  ? new Date(search.ToDate ?? "")
                  : null
              }
              minDate={
                search.FromDate && search.FromDate?.length > 0
                  ? new Date(search.FromDate)
                  : undefined
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000
                      )?.toISOString()
                    : "",
                  "ToDate",
                  setSearch
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Chi nhánh"
              leftSection={<IconBuildingSkyscraper color="#15aabf" />}
              data={dataBranchSelect}
              value={search.MaCty ? String(search.MaCty) : ""}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) =>
                changeSearchValue(e ? e : "", "MaCty", setSearch)
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default CompareDefectivePOSAndAsia;
